import {
  BadgeProps, ICON_ALERT_CIRCLE_OUTLINE, ICON_CHECK_CIRCLE_OUTLINE, ICON_PROGRESS_CHECK,
} from '@doveit/bricks';
import { InvoiceStatus } from '../domain/types/invoiceStatus';

export const invoiceStatusLabels: Record<InvoiceStatus, string> = {
  [InvoiceStatus.DRAFT]: 'Richiesto',
  [InvoiceStatus.PROFORMA]: 'Emesso',
  [InvoiceStatus.BILLED]: 'Fatturato',
  [InvoiceStatus.PAID]: 'Pagato',
  [InvoiceStatus.NOT_PAID]: 'Non pagato',
  [InvoiceStatus.COLLECTED]: 'Incassato',
};

export const invoiceStatusColors: Record<InvoiceStatus, BadgeProps['color']> = {
  [InvoiceStatus.DRAFT]: 'warning',
  [InvoiceStatus.PROFORMA]: 'info',
  [InvoiceStatus.BILLED]: 'info',
  [InvoiceStatus.PAID]: 'success',
  [InvoiceStatus.COLLECTED]: 'success',
  [InvoiceStatus.NOT_PAID]: 'critical',
};

export const invoiceStatusIcons: Record<InvoiceStatus, string> = {
  [InvoiceStatus.DRAFT]: ICON_PROGRESS_CHECK,
  [InvoiceStatus.PROFORMA]: ICON_PROGRESS_CHECK,
  [InvoiceStatus.BILLED]: ICON_PROGRESS_CHECK,
  [InvoiceStatus.PAID]: ICON_PROGRESS_CHECK,
  [InvoiceStatus.NOT_PAID]: ICON_ALERT_CIRCLE_OUTLINE,
  [InvoiceStatus.COLLECTED]: ICON_CHECK_CIRCLE_OUTLINE,
};
